import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PaymentStatusDto } from '@api-client';

/**
 * Test-only override for the tenant payment-status popup (ZEY-3046).
 *
 * When `set()` has been called with a value, the app shell uses that DTO
 * instead of the real settings response — letting an operator preview every
 * tier/payAction combination from the hidden /recalculation > Banner Test tab.
 *
 * Override is in-memory only (no persistence) — a page reload clears it.
 */
@Injectable({ providedIn: 'root' })
export class PaymentStatusOverrideStore {
  private readonly subject = new BehaviorSubject<PaymentStatusDto | null>(null);

  readonly override$: Observable<PaymentStatusDto | null> = this.subject.asObservable();

  set(value: PaymentStatusDto): void {
    this.subject.next(value);
  }

  clear(): void {
    this.subject.next(null);
  }

  get current(): PaymentStatusDto | null {
    return this.subject.value;
  }
}
